export default __webpack_public_path__ + "static/media/darktemplar_white_icon.1591059a.png";